export class ShipmentActionAddAddon {
    public shipmentId: number = 0
    public stopId: number = 0
    public orderIds: string[] = []
    public rowVersion: string
}